import MicroModal from 'micromodal'

const MODAL_ID = 'promo-modal'

/**
 * Promo popup — open the campaign banner on every load of the page.
 *
 * Must run after MicroModal.init: in micromodal 0.7, init's options become the
 * defaults every later show() inherits, so this dialog gets the same scroll
 * lock, close animation and focus handling as the legal modals.
 */
export function initPromoPopup() {
    const modal = document.getElementById(MODAL_ID)
    if (!modal) return

    // The banner opens the microsite in a new tab; close the dialog behind it so
    // the visitor doesn't come back to the popup still sitting over the page.
    modal.querySelector('[data-promo-link]')?.addEventListener('click', () => MicroModal.close(MODAL_ID))

    MicroModal.show(MODAL_ID)
}
